import {ChangeDetectionStrategy, Component, input, numberAttribute, output} from '@angular/core'
import {faTimes} from '@fortawesome/pro-regular-svg-icons/faTimes'
import {LinkService} from '../../../core/i18n/link.service'
import {faUser} from '@fortawesome/pro-solid-svg-icons/faUser'
import {TranslocoModule} from '@ngneat/transloco'
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome'
import {RouterModule} from '@angular/router'
import {CommonModule, NgOptimizedImage} from '@angular/common'
import {DialogModule} from '../../../craft/dialog/dialog.module'
import {ButtonModule} from '../../../craft/button/button.module'
import {ProgressStep, ProgressStepperComponent} from '../../../craft/progress-steps/progress-stepper.component'

@Component({
  selector: 'bgo-process-navbar',
  templateUrl: './process-navbar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FontAwesomeModule,
    RouterModule,
    TranslocoModule,
    CommonModule,
    NgOptimizedImage,
    DialogModule,
    ButtonModule,
    ProgressStepperComponent,
  ],
})
export class ProcessNavbarComponent {
  steps = input.required<ProgressStep[]>()
  activeStep = input(undefined, {transform: numberAttribute})
  showStepper = input<StepperPosition>('auto')
  agencyLogo = input<{title?: string; url: string} | undefined>()

  closed = output<true>()

  readonly closeIcon = faTimes
  readonly contactIcon = faUser
  readonly homePath = this.linkService.homePath

  constructor(private readonly linkService: LinkService) {}
}

export type StepperPosition = 'hidden' | 'auto' | 'below'
